import { render, staticRenderFns } from "./navgjjs.vue?vue&type=template&id=7f61f0cd&scoped=true&"
import script from "./navgjjs.vue?vue&type=script&lang=js&"
export * from "./navgjjs.vue?vue&type=script&lang=js&"
import style0 from "./navgjjs.vue?vue&type=style&index=0&id=7f61f0cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61f0cd",
  null
  
)

export default component.exports